<template>
  <ConversationAnalyzeCategories :conversationsSource="conversationsSource" :fields="fields" :conversationsTargetRoute="conversationsTargetRoute" :enableEscalated="true" :enableTTA="true"></ConversationAnalyzeCategories>
</template>

<script setup>
  import ConversationAnalyzeCategories from '@/components/Analytics/ConversationAnalyzeCategories.vue';

  const conversationsSource = 'bot';
  const fields = {
    category: 'analysis.category',
    subcategory: 'analysis.subcategory',
    subsubcategory: 'analysis.subsubcategory',
    csat: 'CSat',
    tta: 'state.timeToAgent',
  };
  const conversationsTargetRoute = '/bots/conversations';
</script>
